import React, { useContext } from 'react'
import styled from 'styled-components/macro'
import { ContentsErrorContext } from '../../../hooks/useAddressTypeContext'
import FileNotFoundImg from '../../../assets/img/file_not_found.png'
import SeverErrorImg from '../../../assets/img/500-sever-error.png'

type Props = {
  children: JSX.Element
}

function ErrorLayout({ children }: Props) {
  const { contentErrorStatus } = useContext(ContentsErrorContext)
  const renderContext = () => {
    if (contentErrorStatus >= 500) {
      return <ServerError />
    }
    if (contentErrorStatus >= 400) {
      return <NotFound />
    }
    return children
  }
  return renderContext()
}

export default ErrorLayout

function NotFound() {
  return (
    <NotFoundWrapper>
      <NotFoundContent>
        <NotFoundImg alt="NotFoundImg" src={FileNotFoundImg} />
        <br />
        <NotFoundTitle>Search not found</NotFoundTitle>
        <NotFoundText>
          Sorry,
          <br />
          Your query didn’t return any results.
        </NotFoundText>
      </NotFoundContent>
    </NotFoundWrapper>
  )
}

function ServerError() {
  return (
    <NotFoundWrapper>
      <NotFoundContent>
        <NotFoundImg alt="ServerErrorImg" src={SeverErrorImg} />
        <br />
        <NotFoundTitle>500 Server error</NotFoundTitle>
        <NotFoundText>Oops something went wrong.</NotFoundText>
      </NotFoundContent>
    </NotFoundWrapper>
  )
}

const NotFoundWrapper = styled.section`
  width: 100%;
`
const NotFoundContent = styled.div`
  font-family: roboto;
  text-align: center;
  padding: 5rem 0;
`

const NotFoundImg = styled.img`
  padding-bottom: 2.4rem;
`

const NotFoundTitle = styled.h3`
  margin-bottom: 0.8rem;
  font-size: 1rem;
`

const NotFoundText = styled.p`
  font-size: 0.6rem;
  line-height: 0.9rem;
  margin-bottom: 1rem;
`
